export const KEY = {
  ACCESS_TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  USERNAME: 'username',
  PASSWORD: 'password',
  ROOM_ENV: 'roomEnv',
  LOCALE_CODE: 'localeCode',
} as const;
